/** Styl pro input textu k tématu Erma */
export const InputtextStyles = {
  borderColor: 'var(--erma-secondary-300)',
  borderRadius: 'var(--erma-border-radius-sm)',
  paddingY: '.429rem',
  paddingX: '.429rem',
  invalidBorderColor: '#a94442',
  hoverBorderColor: "var(--erma-secondary-300)"
};
